require('./small-sized-decimal.jade')

SmallSizedDecimalDirective = (NumberService)->
  restrict: "A"
  replace: true
  templateUrl: "components/number/small-sized-decimal.jade"
  scope:
    floatNumber: '=val'
    prefix: '@?'
  link: (scope) ->
    scope.$watch (-> scope.floatNumber), ->
      return unless scope.floatNumber
      if scope.floatNumber is 0 or scope.floatNumber is 100
        scope.integerPart = scope.floatNumber
        scope.fractionPart = ''
        return
      scope.integerPart = NumberService.getIntegerPart scope.floatNumber
      scope.fractionPart = NumberService.getFractionalPart scope.floatNumber

SmallSizedDecimalDirective.$inject = [
  'NumberService'
]

module.exports = SmallSizedDecimalDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/number/small-sized-decimal-directive.coffee